import React from "react";
import "./Modal.css";

const Modal = ({ showModal, setShowModal, children }) => {
    if (!showModal) return null;

    return (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="close-btn" onClick={() => setShowModal(false)}>✖</button>
                {children}
            </div>
        </div>
    );
};

export default Modal;
